export enum RoutesSettings {
  SETTINGS = 'settings',
  GENERAL = 'general',
  SCHOOL = 'school',
  PROFILE = 'profile',
  INTEGRATIONS = 'integrations',
  ACCOUNT = 'account',
  CONTRACTS = 'contracts',
  ALL_CONTRACTS = 'all',
  USERS = 'users',
  GOODS = 'goods',
  ACCESS = 'access',
  FINANCIAL = 'financial',
  SUBSCRIPTIONS = 'subscriptions',
  USER_ROLES_NEW = 'users/role/new',
  USER_ROLE_EDIT = 'users/role/:roleId',
  CONTRACT = 'contract',
  NOTIFICATIONS = 'notifications',
  BILLING = 'billing',
  LOGOS = 'logos',
  WHATSAPP = 'whatsapp',
  CHANNELS = 'channels',
  NAVIGATE_PROFILE = '/settings/profile',
  NAVIGATE_ACCOUNT = '/settings/account',
  NAVIGATE_CONTRACTS = '/settings/contracts/model/all',
  NAVIGATE_NOTIFICATIONS = '/settings/notifications',
  NAVIGATE_BILLING = '/settings/billing',
  NAVIGATE_LOGOS = '/settings/logos',
  NAVIGATE_INTEGRATIONS = '/settings/integrations',
  NAVIGATE_SUBSCRIPTIONS = '/settings/subscriptions',
  NAVIGATE_USERS = '/settings/users',
  NAVIGATE_DASHBOARD = '/dashboard',
  SERVICES = 'services',
  BOOKINGS = 'bookings',
  CRM = 'crm',
  TREINO = 'treino',
  HOTSITE = 'hotsite',
  HELPDESK = 'helpdesk',
  POSTS = 'posts',
}
